import { use } from 'react'

import cn from 'classnames'

import { ConversationEmptyState } from '@app/components/ConversationEmptyState'
import config from '@app/config'
import { ChatContext } from '@app/context'
import { navigationFeatureEnabled } from '@app/helpers'
import {
  useConversation,
  useConversationID,
  useIsStaff,
} from '@app/hooks'
import { isB2BView, isBuyerView } from '@app/utils'

import { Loader } from '@lib/components'

import { Header, ListItem } from './components'
import styles from './styles.module.scss'
import { useConversationList } from './useConversationList'

export const List = () => {
  const { state } = use(ChatContext)

  const isStaff = useIsStaff()
  const conversation = useConversation()
  const conversationId = useConversationID()
  const { conversations, loading, succeed, handleScroll } =
    useConversationList()
  const shouldDisplayLoading = isBuyerView() && isStaff
  const isB2B = isB2BView()
  const canShowSpamFilter = state.hasSpam || isStaff
  const shouldShowListFilters = isB2B || canShowSpamFilter
  const hasBottomNavigation = navigationFeatureEnabled()

  const conversationBlockClassName = cn(styles.conversationBlock, {
    [styles.selected]: Boolean(conversationId),
    [styles.withBottomNavigation]: hasBottomNavigation,
  })

  const conversationListStyle = cn(styles.conversationList, {
    [styles.listWebView]: config.identity.isB2CWebView,
    [styles.withBottomNavigation]: hasBottomNavigation,
    [styles.withFilters]: shouldShowListFilters,
  })

  return (
    <div className={conversationBlockClassName}>
      <Header />
      {state.fetching === 'PENDING' || shouldDisplayLoading ? (
        <Loader />
      ) : (
        <>
          {!conversations.length && succeed && (
            <ConversationEmptyState
              mode="list"
            />
          )}
          {conversations.length > 0 && (
            <div
              onScroll={handleScroll}
              className={conversationListStyle}
              id="conversationList"
            >
              {conversations.map((item) => (
                <ListItem
                  key={item.id}
                  conversation={item}
                  selected={conversation?.id === item.id}
                />
              ))}
              {loading && <Loader />}
            </div>
          )}
        </>
      )}
    </div>
  )
}
